import React, { Component, Suspense } from "react";
import Edit from "../../image/icons/edit.png";
import tick from "../../image/icons/tick.png";
import Deactivate from "../../image/icons/deactvate.png";
import { apiCalling } from "../../apiService";
import $ from "jquery";
import Pagination from "react-js-pagination";
import Header from "../../layout/header"
import Footer from "../../layout/footer"
import { Link } from "react-router-dom";
import Logoimg from "../../image/icons/image-preview.png";

export default class HospitalBannerdetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hospitalBannerData: [],
            totalCount: 0,
            activePage: 1,
            showMessage: "Waiting for data... "
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        var offset;
        var max;
        let cmbCategory = $("#cmbCategory").val() === '0' ? '' : $("#cmbCategory").val();
        let txtInput = $("#txtInput").val();
        let cmbStatus = $("#cmbStatus").val() === '0' ? '' : $("#cmbStatus").val();
        if (pageNumber === "1") {
            offset = "0";
            max = "10";
            this.setState({
                activePage: pageNumber,
                isLoading: '0'
            })
        }
        else {
            offset = parseInt(pageNumber - 1) * 10;
            max = "10";
            this.setState({
                activePage: pageNumber,
                isLoading: '0'
            })
        }
        const apiJson = {
            method: "POST",
            body: JSON.stringify({
                functionName: "getHospitalBannerUploadList",
                cmbCategory: cmbCategory,
                txtInput: txtInput,
                cmbStatus: cmbStatus,
                Offset: JSON.stringify(offset),
                max: max
            }),
        };
        $(".loader").show();
        apiCalling(apiJson).then((data) => {
            if (data.success === "1") {

                this.setState({
                    hospitalBannerData: data.hospitalBannerData,
                    totalCount: data.totalCount,
                });
                $(".loader").hide();
            }
        });
    }

    componentDidMount() {

        this.gethospitalBannerData();
    }

    gethospitalBannerData() {
        $(".loader").show();
        const apiJson = {
            method: "POST",
            body: JSON.stringify({
                functionName: "getHospitalBannerUploadList",
                cmbCategory: "",
                txtInput: "",
                cmbStatus: "",
                Offset: "0",
                max: "10"
            }),
        };
        apiCalling(apiJson).then((data) => {
            if (data.success === "1") {
                $(".loader").hide();
                this.setState({
                    hospitalBannerData: data.hospitalBannerData,
                    totalCount: data.totalCount,
                });
            }
            if (data.success === "0") {
                $(".loader").hide();
                this.setState({
                    hospitalBannerData: [],
                    showMessage: data.errorMessage
                });
            }
        });
    }

    changeText = () => {
        if ($("#cmbCategory").val() !== '0') {
            document.getElementById("txtInput").disabled = false
            $('input[name=txtInput]').focus();
        }
        else {
            document.getElementById("txtInput").disabled = true
        }
        document.getElementById("txtInput").value = ""
    }

    searchHandler() {

        let cmbCategory = $("#cmbCategory").val() === '0' ? '' : $("#cmbCategory").val();
        let txtInput = $("#txtInput").val();
        let cmbStatus = $("#cmbStatus").val() === '0' ? '' : $("#cmbStatus").val();

        if ($("#cmbCategory").val() !== "0" && $("#txtInput").val() === "") {
            var t = document.getElementById("cmbCategory");
            var selectedText = t.options[t.selectedIndex].text;
            alert(selectedText + " Required");
            $("#txtInput").focus();
            return false;
        } else {
            const searchData = {
                method: "POST",
                body: JSON.stringify({
                    functionName: "getHospitalBannerUploadList",
                    cmbCategory: cmbCategory,
                    txtInput: txtInput,
                    cmbStatus: cmbStatus,
                    Offset: '0',
                    max: '10'
                }),
            };
            $(".loader").show();
            apiCalling(searchData).then((data) => {
                if (data.success === "1") {
                    $("#paginationType").show();
                    $(".loader").hide();
                    this.setState({
                        hospitalBannerData: data.hospitalBannerData,
                        totalCount: data.totalCount,
                        activePage: 1,
                    });
                }
                if (data.success === "0") {
                    $("#paginationType").hide();
                    $(".loader").hide();
                    this.setState({
                        hospitalBannerData: [],
                        showMessage: data.errorMessage
                    });
                }
            })
        }
    }

    statusChangeHandler(id, Status) {

        var x = false;
        if (Status === true) {
            x = window.confirm("Do you want to Disable this?")
        }
        else {
            x = window.confirm("Do you want to Enable this?")
        }
        if (x === true) {
            const SatusData = {
                method: "POST",
                body: JSON.stringify({
                    functionName: "bannerStatusChange",
                    hospitalBannerId: id,
                    isActive: Status === true ? 0 : 1
                }),
            };
            $(".loader").show();
            apiCalling(SatusData).then((data) => {
                if (data.success === "1") {
                    $(".loader").hide();
                    alert("Status Changed Successfully")
                    this.gethospitalBannerData()
                }
                if (data.success === "0") {
                    $(".loader").hide();
                    alert(data.errorMessage)
                }
            })
        }
    }

    srcTypeImage(ev) {
        ev.target.src = Logoimg;
    }


    render() {
        return (
            <div className="purpleWrap bg-clr-wthHead">
                <Suspense fallback={<div></div>}>
                    <section>
                        <Header />{" "}
                        <div className='loader'></div>
                    </section>
                </Suspense>
                <div className='loader'></div>
                <div className="container mb-5">
                    <div>
                        <ul className="breadcrum-adminMangmnt">
                            <li><a href="/admin/dashboardAdmin">Dashboard</a></li>
                            <li><a href="" className="current">Hospital Banner Listing</a></li>
                        </ul>
                    </div>
                    <div className="head-hospMangmntList">Hospital Banner Details</div>

                    <div className="HosptlMangemntTable">
                        <div className="AddNewHspbtnDiv">
                            <a href="/adminManagement/mobileAppdashboard/addBanner" className="addnewhspbtn"> Add Banner</a>
                        </div>
                        <div className="tableHeader-HspMangemnt">
                            <div className="selectField-HspMangmnt" >
                                <select className="slecthsp slecthspMob" name="cmbCategory" id="cmbCategory" onChange={() => this.changeText()} >
                                    <option value="0">Search In</option>
                                    <option value="id">ID</option>
                                    <option value="hospitalId">Hospital Id</option>
                                    <option value="title">Title</option>
                                    <option value="hospitalName">Hospital Name</option>
                                </select>
                            </div>
                            <div className="selectField-HspMangmnt">
                                <input type="text" className="hspmngInput hspbanerInputmob" id="txtInput" name="txtInput" disabled />
                            </div>
                            <div className="selectField-HspMangmnt">
                                <select className="slecthsp slecthspMob" name="cmbStatus" id="cmbStatus">
                                    <option value="0">Status</option>
                                    <option value="true">Active</option>
                                    <option value="false">InActive</option>
                                    <option value="1">App BAnner Yes</option>
                                    <option value="2">App Banner No</option>
                                </select>
                            </div>
                            <div className="selectField-HspMangmnt">
                                <button className="searchbtn-hspMng" onClick={() => this.searchHandler()}>Search</button>
                            </div>
                        </div>
                        {this.state.hospitalBannerData.length > 0 ?
                            <div className="table-responsive table-baner-res">
                                <table className="table table-bordered-hsp">
                                    <thead>
                                        <tr>
                                            <th className="tablehead-hspmng">ID</th>
                                            <th className="tablehead-hspmng">Hospital Id</th>
                                            <th className="tablehead-hspmng">Hospital Name</th>
                                            <th className="tablehead-hspmng">Title</th>
                                            <th className="tablehead-hspmng">Image Tumb</th>
                                            <th className="tablehead-hspmng">Is App</th>
                                            <th className="tablehead-hspmng">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.hospitalBannerData.map((data) => (
                                            <tr>
                                                <td>{data.hospitalbannerId}</td>
                                                <td>{data.hospitalId}</td>
                                                <td>{data.hopsitalName}</td>
                                                <td>{data.title}</td>
                                                <td><span className="bannerthumbImg"><img onError={this.srcTypeImage} src={data.imageFullpath} alt="" /></span></td>
                                                <td>{data.isappbanner===true?'Yes':'No'}</td>
                                                <td className="nowrap">
                                                    <div>
                                                        <span><Link to={"/adminManagement/mobileAppdashboard/addBanner/" +data.hospitalbannerId} className="mr-2"><img src={Edit} title="Edit "  alt="" width="18" className="img-fluid  conf-cursorpointer" /></Link></span>
                                                        {data.isActive === true ? <img src={tick} width="22" title="Click to Deactivate " className="mr-2 conf-cursorpointer" alt="" onClick={() => { this.statusChangeHandler(data.hospitalbannerId, true) }}></img> : 
                                                        <img src={Deactivate} alt="" title="Click to Activate" className="mr-2 conf-cursorpointer" width="20" onClick={() => { this.statusChangeHandler(data.hospitalbannerId, false) }}></img>}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {this.state.totalCount > 5 ?
                                    <div className="pagination-qualList pagination-qualListwidth">
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={10}
                                            totalItemsCount={this.state.totalCount}
                                            pageRangeDisplayed={10}
                                            onChange={this.handlePageChange}
                                        />
                                    </div>
                                    : ""}
                            </div>
                            :
                            <p className="error-msg text-center mb-0"> {this.state.showMessage} </p>
                        }
                    </div>
                </div>
                <Suspense fallback={<div></div>}>
                    <section>
                        <Footer />
                    </section>
                </Suspense>
            </div>
        );
    }
}
